<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <!-- <div class="card-body p-2	vertex-card d-flex" >
            <span class="text-default" style="font-size:16px; font-weight: 900;">Training Summary Status</span>

            <div style="text-align: center; align-items: center;">
              <img class="img-fluid center-block circle" :src="orgLogo" alt="" style="min-width:100px;">
            </div>
            <p class="event_desc text-truncate" :title="orgName" style=""><span :title="orgName">{{orgName}}</span></p>
          </div> -->
          <div class="card-body p-3 card-summary">
            <div class="row">
              <div class="col-12 text-wrap text-start">
                <p style="font-size:16px; color:white;">Training Summary Status</p>
              </div>
              <div class="p-1">
                <div class="col text-center mx-auto" v-if="!pieReady">
                  <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
                  <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
                </div>
                <div class="col mt-2" style="min-height:170px;" v-else>
                  <apexchart v-if="pieReady" width="330px" type="donut" class="mx-auto" :options="pieOptions" :series="pieSeries" />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="d-flex ms-1 p-1">
                <button :disabled="downloading" type="button" class="btn btn-labeled default btn-sm" v-tooltip.top="'Download Report'" :class="{ 'text-small': vssWidth <= 1065  }"   @mouseover="btnDownload = 'white'" @mouseleave="btnDownload= '#00A0C1'" @click="downloadEmployeeSummary">
                  <div v-if="downloading" class="spinner-border" role="status" style="height:15px; width:15px;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span class="btn-label" v-if="!downloading">
                  <svg width="17" :height="vssWidth <= 1065 ? 14 : 16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.35682 11.3864C8.37383 11.4081 8.39556 11.4257 8.42036 11.4378C8.44517 11.4498 8.4724 11.4561 8.5 11.4561C8.5276 11.4561 8.55483 11.4498 8.57964 11.4378C8.60444 11.4257 8.62617 11.4081 8.64318 11.3864L11.1886 8.16591C11.2818 8.04773 11.1977 7.87273 11.0455 7.87273H9.36136V0.181818C9.36136 0.0818182 9.27955 0 9.17955 0H7.81591C7.71591 0 7.63409 0.0818182 7.63409 0.181818V7.87045H5.95455C5.80227 7.87045 5.71818 8.04546 5.81136 8.16364L8.35682 11.3864ZM16.8182 10.5909H15.4545C15.3545 10.5909 15.2727 10.6727 15.2727 10.7727V14.2727H1.72727V10.7727C1.72727 10.6727 1.64545 10.5909 1.54545 10.5909H0.181818C0.0818182 10.5909 0 10.6727 0 10.7727V15.2727C0 15.675 0.325 16 0.727273 16H16.2727C16.675 16 17 15.675 17 15.2727V10.7727C17 10.6727 16.9182 10.5909 16.8182 10.5909Z" :fill="btnDownload"/>
                  </svg></span> <span class="d-none d-sm-inline">Detailed Employee Report (.xlsx)</span>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
       </div>
   </div>
 </template>

 <script>
import * as XLSX from 'xlsx'
import moment from 'moment';

   export default {
    name: 'Dashboard',

    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          logo: null,
          pieReady: false,
          btnDownload: "#00A0C1",
          downloading: false,
          downloadingSummary: false,
          pieSeries: [],
          pieOptions: {
            redrawOnParentResize: true,
            labels: [],
            chart: {
            height: 'auto',
            type: 'donut',
            fontFamily: 'Roboto, sans-serif',
            offsetX: -17,
            },
            legend: {
                position: 'left'
            },
            responsive: [
              {
                breakpoint: 1760,
                options: {
                  chart: {
                    width: 300
                  },
                  legend: {
                    position: 'top'
                  }
                }
              },
              {
                breakpoint: 960,
                options: {
                  chart: {
                    width: 250
                  },
                  legend: {
                    position: 'top'
                  }
                }
              },
              {
                breakpoint: 765,
                options: {
                  chart: {
                    width: 350
                  },
                  legend: {
                    position: 'top'
                  }
                }
              },
              {
                breakpoint: 420,
                options: {
                  chart: {
                    width: 250
                  },
                  legend: {
                    position: 'top'
                  }
                }
              },
            ],
            colors: ['#1891C3', '#3AC0DA', '#3DC6C3'],

          dataLabels: {
            enabled: false,
          },
          },
          vssWidth: 3000,
      }
    },

    async created() {
      //don't initialize if showProduct is false
      if (!this.showProduct) return

      await this.getData()
      this.vssWidth = this.$vssWidth;

      let org = await this.getOrganisation(this.organisationID)
      this.logo = org.organisation_logo.logo
    },

    methods: {
      getData(){
        this.pieReady = false;

        let params = {
          manager: this.isManager
        }

        return new Promise((resolve, reject) => {
        this.$axios.get("/trainings/organisations/"+this.organisationID +"/answers/pie-summary", {params})
        .then(response => {
          if (response.data.success) {
            var total = 0;
            for (const summary of response.data.pie_summary) {
              total += summary.value
            }

            for (const summary of response.data.pie_summary) {
              this.pieSeries.push(summary.value)

              var percentage = (summary.value / total) * 100
              this.pieOptions.labels.push(summary.name + " "  + "(" + percentage.toFixed(2) + '%' + ")")
            }

            this.pieReady = true
            resolve()
          }
        }).catch(error => {
            reject(error)
          })
        })
    },

    async downloadEmployeeSummary() {
      this.downloading = true;

      if(this.downloadingSummary)
        return

      let data = await this.prepareEmployeeSummary();
      var dateToday = moment().format("YYYYMMD");

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */


      XLSX.writeFile(wb, dateToday + "_"+this.formattedOrgName+ "_employee_report.xlsx");

      this.downloadingSummary = false
      this.downloading = false
      this.btnDownload = '#00A0C1';
    },

    async prepareEmployeeSummary() {
      let employeeSummaries = await this.getEmployeeSummary();

      let rows = [["Employee", "Email", "Category", "Program Name", "Frequency", "Training Topic", "Type", "Mandatory", "Status" ,"Quiz Status", "Date Assigned","Date Completed" ,"Quiz Score", "# of Quiz Attempt", "Ad Hoc"]];

      for (const employeeSummary of employeeSummaries) {
          let quizDate = employeeSummary["Date Completed"]

          if (quizDate != "") {
              quizDate = moment(employeeSummary["Date Completed"]).local().format("DD/MM/yyyy")
          }

          // ADDED: Pushing the new variables into their slots
          rows.push([
              employeeSummary["Employee"],
              employeeSummary["Email"],
              employeeSummary["Category"] || "N/A",
              employeeSummary["Program Name"] || "N/A",
              employeeSummary["Frequency"] || "N/A",
              employeeSummary["Training Topic"],
              employeeSummary["Type"],
              employeeSummary["Mandatory"] ? "Yes" : "No",
              employeeSummary["Status"],
              employeeSummary["Quiz Status"],
              moment(employeeSummary["Date Assigned"]).local().format("DD/MM/yyyy"),
              quizDate,
              employeeSummary["Quiz Score"],
              employeeSummary["# of Quiz Attempt"],
              employeeSummary["Ad Hoc"] ? "Yes" : "",
          ]);
      }
      return rows;
    },

    async getEmployeeSummary() {
      if (!this.$store.state.user.organisation) {return;}

      let params = {
        manager: this.isManager
      }
      let data = await this.$axios
          .get("/trainings/organisations/" + this.organisationID + "/answers/summary", {params})
          .then((response) => {
              return response.data.quiz_summary
          })
          .catch();

      return data;

    },

    async getOrganisation(id){
      return await this.$axios.get(`/organisations/` + id)
      .then((response) => {
        if (response.data.success){
          return response.data.organisation;
        } else {
          this.$toast.error(response.data.message);
          return;
        }
      })
      .catch()
    },


  },

  computed: {
    orgName(){
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
    },

    formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },

    orgLogo() {
      var logoData = null

      if (!this.logo)
        return require("@/assets/img/auth-sm.png")

      if (this.logo.length != null)
      logoData = this.logo

      return logoData ? this.logo : require("@/assets/img/auth-sm.png")
    },
  }

  }

 </script>
 <style>
 .vertex-card {
   border-radius: 15px;
   height:120px;
   color:white;

   background: #00a0c1; /* Old browsers */
     background: linear-gradient(to bottom, #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

 .card-summary {
    border-radius: 15px;
   /* max-width: 584px; */

   background: #00a0c1; /* Old browsers */
     background: -moz-linear-gradient(top,  #00a0c1 0%, #00a0c1 50px, #ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

 @media only screen and (min-width: 768px) {
  .card-summary {
   max-width: 100%;
 }

 .vertex-card {
   max-width: 100%;
 }
}

 p.event_desc {
  position: relative;
  top: 0%;
  left: 0px;
  width: 60%;
  font-size:16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  height:75px;
  margin: 0px;
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  text-shadow:
    -1px -1px 0 #00a0c1,
     1px -1px 0 #00a0c1,
    -1px  1px 0 #00a0c1,
     1px  1px 0 #00a0c1;
}

.apexcharts-canvas{
  margin: auto;
}

.circle {
  border-radius: 50%;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:white;
  border:1px solid #D3E4E8;
  object-fit: fill;
}

.apexcharts-legend-text {
  font-size: .85rem !important;
  font-family: 'Roboto', sans-serif !important;
}
 </style>